import template   from './manage-purchase.html'
import './manage-purchase.styl'

let component = {
  restrict: 'E',
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/manage-purchase.component.js